import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractBffApi} from '../../models/sharedinterface';
import {BffApi} from '../../models/bff-api';
import {GlobalsService} from './globals.service';
import {BcApi} from '../../models/bc-api';

@Injectable({
  providedIn: 'root'
})
export class ApiFactoryService {

  constructor(
    private http: HttpClient,
    private globalsservice: GlobalsService
  ) {
  }

  createBffApi(): AbstractBffApi {
    return new BffApi(this.http, this.globalsservice.getBffapiroot(), '');
  } // createBffApi

  createBcApi(): BcApi {
    return new BcApi(this.http, this.globalsservice.getBCapiroot(), '');
  } // createBcApi

  getHttp(): HttpClient {
    return this.http;
  }
}
